module.exports = __webpack_public_path__ + "static/media/restaurant-placeholder.6c930d9e.jpeg";